import React from 'react';
import { lang } from 'src/helpers';

export const Button = ({
  isFirst,
  isLast,
  active,
  label,
  type = 'button',
  onClick,
  flex,
  small,
  medium,
  large,
  tiny,
  light,
  outline,
  dark,
  transparent,
  radius,
  rounded,
  circle,
  primary,
  secondary,
  tertiary,
  quaternary,
  senary,
  septenary,
  blacklight,
  text,
  hover,
  activeClass = 'light',
  className = '',
  style = {},
  width,
  padding,
  loading,
  ...props
}) => {
  // default styles: medium, primary
  let attributes = {
    primary,
    secondary,
    tertiary,
    quaternary,
    senary,
    septenary,
    text,
    blacklight
  };
  let color = Object.keys(attributes).find((k) => !!attributes[k]) || 'primary';

  attributes = {
    small,
    medium,
    large,
    tiny
  };
  let size = Object.keys(attributes).find((k) => !!attributes[k]) || 'medium';

  attributes = {
    light,
    outline,
    dark,
    transparent,
    hover
  };
  let format = Object.keys(attributes).filter((k) => !!attributes[k]) || [];

  attributes = {
    radius,
    rounded,
    circle
  };
  let form = Object.keys(attributes).find((k) => !!attributes[k]) || '';

  if (active) {
    format = format.filter((v) => v != 'dark');
    // format.push('light');
    format.push(activeClass);
  }

  let classNames = [...className.split(' '), 'mc-button', size, color, format.join(' '), form];

  if (flex) classNames.push('mc-grow');
  if (loading) classNames.push('loading');

  let borderStyles = {};
  if (isFirst) {
    borderStyles.borderTopRightRadius = 0;
    borderStyles.borderBottomRightRadius = 0;
  } else if (isLast) {
    borderStyles.borderTopLeftRadius = 0;
    borderStyles.borderBottomLeftRadius = 0;
  } else {
    borderStyles.borderTopRightRadius = 0;
    borderStyles.borderBottomRightRadius = 0;
    borderStyles.borderTopLeftRadius = 0;
    borderStyles.borderBottomLeftRadius = 0;
  }

  const buttonStyle = {
    ...style,
    ...(width !== undefined ? { width } : {}),
    ...(padding !== undefined ? { padding } : {}),
    ...borderStyles
  };

  return (
    <button
      type={type}
      onClick={onClick}
      className={classNames.join(' ')}
      style={buttonStyle}
      {...props}
    >
      <span>{lang.t(label)}</span>
    </button>
  );
};

export const ButtonGroup = (props) => {
  let { options = [], onChange, value } = props;
  return (
    <div className='mc-flex-0' style={{ minWidth: options.length * 0 }}>
      {options.map((option, index) => (
        <Button
          key={option.value}
          {...props}
          isFirst={index == 0}
          isLast={index == options.length - 1}
          label={option.label || index}
          active={option.value == value}
          onClick={() => onChange && onChange(option.value ?? index)}
        />
      ))}
    </div>
  );
};
